// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__QzTcx","consentsList":"PatientConsents_consentsList__3nEVx","consentsListEmpty":"PatientConsents_consentsListEmpty__2Aa7v"};